<template>
  <div class="page-container vip-recharge-trial-card-page">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">VIP管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>VIP体验卡审批</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="page-content" shadow="never">
      <el-form :inline="true" :model="query" size="small" class="query-form">
        <el-form-item label="用户UID">
          <el-input v-model.trim="query.userUid" class="query-input" clearable placeholder="请输入用户UID" />
        </el-form-item>
        <el-form-item label="合伙人UID">
          <el-input v-model.trim="query.topPartnerUid" class="query-input" clearable placeholder="请输入合伙人UID" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.approvalStatus" class="query-select" clearable placeholder="全部">
            <el-option
              v-for="item in approvalStatuses"
              :key="item.code"
              :label="item.label"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="申请时间">
          <el-date-picker
            v-model="query.timeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="timestamp"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
          <el-button v-if="canConfig" @click="openConfig">阈值配置</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="rows" border size="small" style="width: 100%">
        <el-table-column prop="userUid" label="用户UID" width="120" align="center" />
        <el-table-column prop="userTypeName" label="用户类型" width="120" align="center" />
        <el-table-column prop="topPartnerUid" label="合伙人UID" width="130" align="center">
          <template slot-scope="scope">{{ scope.row.topPartnerUid || '--' }}</template>
        </el-table-column>
        <el-table-column prop="approvalStatusName" label="状态" width="110" align="center" />
        <el-table-column label="发放卡券" min-width="210" align="center">
          <template slot-scope="scope">{{ couponText(scope.row) }}</template>
        </el-table-column>
        <el-table-column label="VIP等级" width="100" align="center">
          <template slot-scope="scope">{{ scope.row.vipLevel ? `VIP${scope.row.vipLevel}` : '--' }}</template>
        </el-table-column>
        <el-table-column label="当前净充值" width="150" align="right">
          <template slot-scope="scope">{{ amountText(scope.row.currentNetRechargeUsdt) }}</template>
        </el-table-column>
        <el-table-column label="申请时间" width="170">
          <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="110" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.approvalStatus === 'PENDING' && canReview"
              type="text"
              size="small"
              @click="openReview(scope.row)"
            >
              审核
            </el-button>
            <el-button
              v-if="scope.row.approvalStatus !== 'PENDING' && canRecord"
              type="text"
              size="small"
              @click="openRecord(scope.row)"
            >
              审批记录
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pager"
        background
        layout="total, prev, pager, next, sizes"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="page"
        :page-sizes="[10, 20, 50]"
        @size-change="onSizeChange"
        @current-change="fetchList"
      />
    </el-card>

    <el-dialog
      title="审核"
      :visible.sync="reviewVisible"
      width="760px"
      :close-on-click-modal="false"
      @closed="resetReview"
    >
      <detail-block :detail="detail" />
      <div class="section-title">审核意见</div>
      <el-form :model="reviewForm" label-width="100px" size="small">
        <el-form-item label="审核意见" required>
          <el-select v-model="reviewForm.approvalStatus" placeholder="请选择审核意见" style="width: 260px">
            <el-option label="审核通过" value="APPROVED" />
            <el-option label="审核拒绝" value="REJECTED" />
          </el-select>
        </el-form-item>
        <template v-if="reviewForm.approvalStatus === 'APPROVED'">
          <div class="section-title">发放卡券</div>
          <el-form-item label="卡券类型">
            <el-input value="VIP体验卡" disabled style="width: 220px" />
          </el-form-item>
          <el-form-item label="选择卡券" required>
            <el-select
              v-model="reviewForm.couponId"
              filterable
              placeholder="请选择VIP体验卡"
              style="width: 420px"
            >
              <el-option
                v-for="item in vipCouponOptions"
                :key="item.id"
                :label="item.displayName || item.couponName"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="VIP等级">
            <el-input
              :value="selectedVipCoupon ? `VIP${selectedVipCoupon.vipLevel}` : ''"
              disabled
              placeholder="选择卡券后自动带出"
              style="width: 220px"
            />
          </el-form-item>
          <el-form-item label="卡券有效期">
            <el-input
              :value="selectedVipCoupon ? `${selectedVipCoupon.validDays}天` : ''"
              disabled
              placeholder="选择卡券后自动带出"
              style="width: 220px"
            />
          </el-form-item>
          <el-form-item label="VIP有效期">
            <el-input
              :value="selectedVipCoupon ? `${selectedVipCoupon.vipValidDays}天` : ''"
              disabled
              placeholder="选择卡券后自动带出"
              style="width: 220px"
            />
          </el-form-item>
        </template>
        <el-form-item
          v-if="reviewForm.approvalStatus === 'REJECTED'"
          label="拒绝原因"
          required
        >
          <el-input
            v-model.trim="reviewForm.approvalOpinion"
            type="textarea"
            :rows="4"
            maxlength="200"
            show-word-limit
            placeholder="请输入拒绝原因"
          />
        </el-form-item>
        <el-form-item
          v-if="reviewForm.approvalStatus === 'APPROVED'"
          label="审核备注"
        >
          <el-input
            v-model.trim="reviewForm.approvalOpinion"
            type="textarea"
            :rows="4"
            maxlength="200"
            show-word-limit
            placeholder="请输入审核备注"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="reviewVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitReview">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="审核记录" :visible.sync="recordVisible" width="620px">
      <el-descriptions v-if="detail" :column="1" border size="small" class="record-block">
        <el-descriptions-item label="审核结果">
          <span :class="detail.approvalStatus === 'REJECTED' ? 'status-rejected' : 'status-approved'">
            {{ detail.approvalStatusName || '--' }}
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="审核人">{{ detail.updateBy || '--' }}</el-descriptions-item>
        <el-descriptions-item label="审核时间">{{ formatTime(detail.updateTime) }}</el-descriptions-item>
        <el-descriptions-item :label="detail.approvalStatus === 'REJECTED' ? '拒绝原因' : '审核备注'">
          {{ detail.approvalOpinion || '--' }}
        </el-descriptions-item>
      </el-descriptions>
      <span slot="footer">
        <el-button type="primary" @click="recordVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="阈值配置"
      :visible.sync="configVisible"
      width="520px"
      :close-on-click-modal="false"
    >
      <el-form :model="configForm" label-width="110px" size="small">
        <el-form-item label="阈值" required>
          <el-input-number
            v-model="configForm.thresholdUsdt"
            :min="0.00000001"
            :precision="8"
            :step="100"
            controls-position="right"
            style="width: 220px"
          />
          <span class="unit">U</span>
        </el-form-item>
        <el-form-item label="VIP等级" required>
          <el-select v-model="configForm.vipLevel" placeholder="请选择VIP等级" style="width: 220px">
            <el-option
              v-for="item in vipLevelOptions"
              :key="item.code"
              :label="item.label"
              :value="Number(item.code)"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="configVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitConfig">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { Message, MessageBox } from 'element-ui';
import { hasPerm } from 'common/permission';
import api from './api';
import DetailBlock from './components/DetailBlock.vue';

function emptyQuery() {
  return {
    userUid: '',
    topPartnerUid: '',
    approvalStatus: '',
    timeRange: [],
  };
}

export default {
  name: 'VipRechargeTrialCardApprovalPage',
  components: { DetailBlock },
  data() {
    return {
      query: emptyQuery(),
      rows: [],
      total: 0,
      page: 1,
      pageSize: 20,
      approvalStatuses: [],
      reviewVisible: false,
      recordVisible: false,
      configVisible: false,
      detail: null,
      reviewForm: {
        approvalStatus: '',
        approvalOpinion: '',
        couponId: '',
      },
      configForm: {
        thresholdUsdt: 20000,
        vipLevel: 5,
      },
      vipLevelOptions: [],
      vipCouponOptions: [],
    };
  },
  computed: {
    ...mapState(['userInfo']),
    canReview() {
      return hasPerm(this.userInfo || {}, 'tenant:vip_recharge_trial_card_approval:review');
    },
    canRecord() {
      return hasPerm(this.userInfo || {}, 'tenant:vip_recharge_trial_card_approval:record');
    },
    canConfig() {
      return hasPerm(this.userInfo || {}, 'tenant:vip_recharge_trial_card_approval:config');
    },
    selectedVipCoupon() {
      return this.vipCouponOptions.find((item) => String(item.id) === String(this.reviewForm.couponId)) || null;
    },
  },
  created() {
    this.loadEnums();
    this.fetchList();
  },
  methods: {
    async loadEnums() {
      const res = await api.enums();
      const data = (res && res.data) || {};
      this.approvalStatuses = data.approvalStatuses || [];
    },
    async fetchList() {
      const params = {
        page: this.page,
        size: this.pageSize,
        userUid: this.query.userUid,
        topPartnerUid: this.query.topPartnerUid,
        approvalStatus: this.query.approvalStatus,
      };
      if (this.query.timeRange && this.query.timeRange.length === 2) {
        params.startTime = this.query.timeRange[0];
        params.endTime = this.query.timeRange[1];
      }
      const res = await api.page(params);
      const data = (res && res.data) || {};
      this.rows = data.items || [];
      this.total = data.total || 0;
    },
    search() {
      this.page = 1;
      this.fetchList();
    },
    resetQuery() {
      this.query = emptyQuery();
      this.search();
    },
    onSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.fetchList();
    },
    async openReview(row) {
      const [detailRes, couponRes, configRes] = await Promise.all([
        api.detail(row.id),
        api.couponOptions(),
        api.config(),
      ]);
      this.detail = (detailRes && detailRes.data) || null;
      this.vipCouponOptions = (couponRes && couponRes.data) || [];
      const config = (configRes && configRes.data) || {};
      const defaultCoupon = this.vipCouponOptions.find(
        (item) => Number(item.vipLevel) === Number(config.vipLevel),
      );
      this.reviewForm = {
        approvalStatus: 'APPROVED',
        approvalOpinion: '',
        couponId: defaultCoupon ? defaultCoupon.id : '',
      };
      this.reviewVisible = true;
    },
    async openRecord(row) {
      await this.loadDetail(row.id);
      this.recordVisible = true;
    },
    async loadDetail(id) {
      const res = await api.detail(id);
      this.detail = (res && res.data) || null;
    },
    resetReview() {
      this.reviewForm = { approvalStatus: '', approvalOpinion: '', couponId: '' };
      this.vipCouponOptions = [];
      this.detail = null;
    },
    submitReview() {
      if (!this.reviewForm.approvalStatus) {
        Message.warning('请选择审核意见');
        return;
      }
      if (this.reviewForm.approvalStatus === 'REJECTED' && !this.reviewForm.approvalOpinion) {
        Message.warning('请填写拒绝原因');
        return;
      }
      if (this.reviewForm.approvalStatus === 'APPROVED' && !this.reviewForm.couponId) {
        Message.warning('请选择VIP体验卡');
        return;
      }
      MessageBox.confirm('确认提交审核结果？', '提示', { type: 'warning' })
        .then(() => this.doReview())
        .catch(() => {});
    },
    async doReview() {
      await api.review({
        id: this.detail.id,
        approvalStatus: this.reviewForm.approvalStatus,
        approvalOpinion: this.reviewForm.approvalOpinion || null,
        couponId: this.reviewForm.approvalStatus === 'APPROVED' ? this.reviewForm.couponId : null,
      });
      Message.success('操作成功');
      this.reviewVisible = false;
      this.fetchList();
    },
    async openConfig() {
      const res = await api.config();
      const data = (res && res.data) || {};
      this.vipLevelOptions = data.vipLevels || [];
      this.configForm = {
        thresholdUsdt: Number(data.thresholdUsdt || 20000),
        vipLevel: data.vipLevel || 5,
      };
      this.configVisible = true;
    },
    async submitConfig() {
      if (!this.configForm.thresholdUsdt || Number(this.configForm.thresholdUsdt) <= 0) {
        Message.warning('请输入大于0的阈值');
        return;
      }
      if (!this.configForm.vipLevel) {
        Message.warning('请选择VIP等级');
        return;
      }
      await api.saveConfig(this.configForm);
      Message.success('保存成功');
      this.configVisible = false;
    },
    amountText(value) {
      if (value === null || value === undefined || value === '') return '--';
      const text = String(value);
      return text.includes('.') ? text.replace(/\.?0+$/, '') : text;
    },
    couponText(row) {
      if (!row || !row.couponName) return '--';
      return row.couponNo ? `${row.couponName}(${row.couponNo})` : row.couponName;
    },
    formatTime(value) {
      if (!value) return '--';
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return '--';
      const p = (x) => String(x).padStart(2, '0');
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
    },
  },
};
</script>

<style scoped>
.vip-recharge-trial-card-page {
  padding: 16px;
}
.page-title {
  font-weight: 600;
}
.page-content {
  margin-top: 16px;
}
.query-form {
  margin-bottom: 12px;
}
.query-input {
  width: 130px;
}
.query-select {
  width: 120px;
}
/deep/ .query-form .el-date-editor--datetimerange {
  width: 330px;
}
.pager {
  margin-top: 16px;
  text-align: right;
}
.section-title {
  margin: 14px 0 10px;
  font-weight: 600;
  color: #1f2f5f;
}
.detail-block {
  margin-bottom: 12px;
}
.record-block {
  margin: 8px 0 12px;
}
.status-approved {
  color: #36a453;
  font-weight: 600;
}
.status-rejected {
  color: #d93025;
  font-weight: 600;
}
.unit {
  margin-left: 8px;
  color: #606266;
}
</style>
